import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

/**
 * Legacy /reservar/:doctorId route.
 * We now use a single unified flow at /dr/:slug. This component looks up the
 * doctor by id, retrieves its slug, and redirects to /dr/:slug so existing
 * shared links keep working.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export default function PublicBookingRedirect() {
  const { doctorId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    axios.get(`${API}/public/doctor/${doctorId}`)
      .then((r) => {
        const slug = r.data?.slug;
        if (slug) navigate(`/reservation/${slug}`, { replace: true });
        else navigate("/", { replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [doctorId, navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] text-stone-500">
      Reindirizzamento…
    </div>
  );
}
